<template>
    <div class="js-author-detail">
        <div class="content-header">
            <ol class="breadcrumb">
                <li>
                    <router-link :to="{ name: 'adminUserList' }">管理员管理</router-link>
                </li>
                <li class="active">(添加账户)</li>
            </ol>
        </div>
        <div class="content-from">
            <el-form ref="formName" :model="saveModel" :rules="rules">
                <el-form-item label="账号" prop="username">
                    <el-input disabled v-model="saveModel.username"></el-input>
                </el-form-item>
                <el-form-item label="角色">
                    <el-input v-model="roleName" disabled></el-input>
                    <el-button type="primary" size="mini" @click="openRoleSelectDialog">选择角色</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="bindRoleUser">保存</el-button>
                    <el-button @click="$router.back(-1)">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
         <div class="content-modal">
            <role-select ref="roleSelect" :success="selectedRoles" :multiple="false"></role-select>
        </div>
    </div>
</template>
<script>
import RoleSelect from '@/views/authority/role-select.vue';
export default {
    data() {
        return {
            roleId: '',
            saveModel: {},
            role:[],
            userId:[],
            roleName:'',
        }
    },
    created() {
        var _this = this;
        _this.userId = _this.$route.query.userId;
        
    },
    mounted(){
        var _this = this;
        if (_this.userId) {
            _this.detailLocalUser();
        }
    },
    methods: {
        detailLocalUser() {
            var _this = this;
            _this.$common.my_ajax({
                url: '/localUser/findUserRoleDetail',
                data: {
                    userId: _this.userId
                },
                success: function(response) {
                    if(response.items){
                      var _localUser = response.items[0];
                      _this.saveModel = _localUser;
                      _this.saveModel.roleId = _localUser.roleId;
                      _this.roleName = response.items[0].roleName;
                    }
                }
            });
        },
        bindRoleUser() {
            var _this = this;
            _this.$refs['formName'].validate((valid) => {
                if (valid) {
                    _this.$common.my_ajax({
                        url: '/userRole/bindRoleUser',
                        data: _this.saveModel,
                        contentType:"application/json",
                        success: function(response) {
                            _this.$message({
                                message: '保存成功',
                                type: 'success',
                                duration: 1000,
                                onClose: function() {
                                 _this.$router.push({ name: 'adminUserList' });
                                 _this.$common.authority();
                                }
                            });
                        }
                    });
                }
            });
        },
        openRoleSelectDialog() {
            this.$refs.roleSelect.openDialog();
        },
        selectedRoles(_role) {
            var _this = this;
            _this.role = _role;
            _this.saveModel.roleId = _this.role.id
            _this.roleName = _role.name;
            _this.$refs.roleSelect.closeDialog();
        },
    },
    viewss: {
        RoleSelect
    },
}
</script>
<style scoped>
</style>